"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adformatAdapter_1 = require("./adapters/adformatAdapter");
var mmxlGetter_1 = require("./datalayerHelpers/mmxlGetter");
var RatecardChecker = (function () {
    function RatecardChecker(calcBaseController) {
        this._calcBaseController = calcBaseController;
        this._hasPlanCalculated = false;
    }
    RatecardChecker.prototype.setPlan = function (plan) {
        this._plan = plan;
        this._hasPlanCalculated = false;
    };
    RatecardChecker.prototype.compareCalcBases = function (stored, rateCardOptions) {
        var _this = this;
        var differences = new Array();
        var promisesToDo = new Array();
        return this.updateCalcBase(rateCardOptions).then(function (updateResult) {
            if (stored && _this._plan.calcBase.length === stored.length) {
                stored.forEach(function (calcBaseItem, cbIndex) {
                    calcBaseItem.mediumGroup.forEach(function (mediumGroup, mgIndex) {
                        var candidate = _.omit(_this._plan.calcBase[cbIndex].mediumGroup[mgIndex], _.isUndefined);
                        var placement = _this._plan.mediumGroups[cbIndex].mediumGroup[mgIndex];
                        promisesToDo.push(_this.getAdFormatPrettyName(placement.medium.key, placement.conditions.online.adFormat, rateCardOptions).then(function (adformatPrettyName) {
                            differences.push(_this.compareCalcBaseItems(placement, adformatPrettyName, mediumGroup, candidate, ItemToCheck.CPM));
                            differences.push(_this.compareCalcBaseItems(placement, adformatPrettyName, mediumGroup, candidate, ItemToCheck.TARGETING));
                            differences.push(_this.compareCalcBaseItems(placement, adformatPrettyName, mediumGroup, candidate, ItemToCheck.FREQUENCYCAPPING));
                            differences.push(_this.compareCalcBaseItems(placement, adformatPrettyName, mediumGroup, candidate, ItemToCheck.FIXEDPRICE));
                            differences.push(_this.compareCalcBaseItems(placement, adformatPrettyName, mediumGroup, candidate, ItemToCheck.ADFORMAT));
                        }));
                    });
                });
            }
            return Promise.all(promisesToDo).then(function (results) {
                return differences.filter(function (item) { return item.hasChanged(); });
            });
        });
    };
    RatecardChecker.prototype.getAdFormatPrettyName = function (key, adformatId, rateCardOptions) {
        return mmxlGetter_1.MmxlGetter.getRateCard(key, rateCardOptions).then(function (rateCard) {
            if (!rateCard) {
                return;
            }
            var theAdformat = _.find(rateCard.adFormats, function (candidate) {
                return (candidate).id === adformatId;
            });
            if (theAdformat) {
                var newAdformat = new adformatAdapter_1.AdFormatAdapter(theAdformat);
                return newAdformat.name;
            }
            else {
                return adformatId;
            }
        });
    };
    RatecardChecker.prototype.compareCalcBaseItems = function (placement, adformat, oldItem, newItem, itemToCheck) {
        return new RatecardComparator(placement, adformat, oldItem, newItem, itemToCheck);
    };
    RatecardChecker.prototype.updateCalcBase = function (rateCardOptions) {
        var _this = this;
        var promisesToDo = new Array();
        if (!this._hasPlanCalculated) {
            this._plan.calcBase = new Array();
            this._plan.mediumGroups.forEach(function (mediumGroup, calcBaseIndex) {
                _this._plan.calcBase.push({});
                _this._plan.calcBase[calcBaseIndex].mediumGroup = new Array();
                mediumGroup.mediumGroup.forEach(function () {
                    _this._plan.calcBase[calcBaseIndex].mediumGroup.push({});
                });
                mediumGroup.mediumGroup.forEach(function (placement, itemIndex) {
                    promisesToDo.push(_this._calcBaseController.updateBaseInfos(placement, rateCardOptions).then(function (calcBaseItem) {
                        _this._plan.calcBase[calcBaseIndex].mediumGroup[itemIndex] = calcBaseItem;
                    }));
                });
            });
        }
        return Promise.all(promisesToDo).then(function (results) {
            _this._hasPlanCalculated = true;
            return Promise.resolve();
        });
    };
    RatecardChecker.prototype.doRatecardFixes = function (fixes, placements) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            fixes.forEach(function (fix) {
                if (fix.action === "old") {
                    var thePlacement = _this.findPlacementByLongTitle(fix.medium, placements);
                    if (thePlacement) {
                        switch (fix.type) {
                            case "cpm":
                                thePlacement.conditions.online.specialCpm = fix.oldValue;
                                break;
                            case "fixed price":
                                thePlacement.conditions.online.specialFixedPrice = fix.oldValue;
                                break;
                            default:
                        }
                    }
                }
            });
            resolve();
        });
    };
    RatecardChecker.prototype.findPlacementByLongTitle = function (longTitle, mediumGroups) {
        var result = undefined;
        mediumGroups.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                if (placement.medium.longTitle === longTitle) {
                    result = placement;
                }
            });
        });
        return result;
    };
    return RatecardChecker;
}());
exports.RatecardChecker = RatecardChecker;
var ItemToCheck;
(function (ItemToCheck) {
    ItemToCheck[ItemToCheck["CPM"] = 0] = "CPM";
    ItemToCheck[ItemToCheck["FIXEDPRICE"] = 1] = "FIXEDPRICE";
    ItemToCheck[ItemToCheck["TARGETING"] = 2] = "TARGETING";
    ItemToCheck[ItemToCheck["FREQUENCYCAPPING"] = 3] = "FREQUENCYCAPPING";
    ItemToCheck[ItemToCheck["ADFORMAT"] = 4] = "ADFORMAT";
})(ItemToCheck || (ItemToCheck = {}));
var RatecardComparator = (function () {
    function RatecardComparator(placement, adformat, oldItem, newItem, itemToCheck) {
        this.medium = placement.medium.longTitle;
        this.adformat = adformat;
        this.compare(oldItem, newItem, itemToCheck);
        this.action = (_.contains(this.type, "targeting")
            || _.contains(this.type, "frequency capping")
            || _.contains(this.type, "adFormat")) ? "info" : "new";
        if (_.contains(this.type, "cpm") && (_.get(oldItem, "cpm.onRequest") === true || _.get(newItem, "cpm.onRequest") === true)) {
            this.action = "info";
        }
    }
    RatecardComparator.prototype.hasChanged = function () {
        var isNaNNumber = function (x) { return x !== x; };
        return (!isNaNNumber(this.oldValue) && !isNaNNumber(this.newValue) &&
            this.oldValue !== undefined && this.newValue !== undefined &&
            this.oldValue !== this.newValue);
    };
    RatecardComparator.prototype.compare = function (oldItem, newItem, itemToCheck) {
        switch (itemToCheck) {
            case ItemToCheck.CPM:
                this.compareCpm(oldItem, newItem);
                break;
            case ItemToCheck.FREQUENCYCAPPING:
                this.compareObjects(oldItem, newItem, "frequencyCapping.value");
                break;
            case ItemToCheck.TARGETING:
                this.compareObjects(oldItem, newItem, "targeting", "value");
                break;
            case ItemToCheck.FIXEDPRICE:
                this.compareObjects(oldItem, newItem, "fixedPrice");
                break;
            case ItemToCheck.ADFORMAT:
                this.compareAdformat(oldItem, newItem, "adFormat");
                break;
            default:
                throw new Error("Unknown ItemToCheck-Type " + itemToCheck);
        }
    };
    RatecardComparator.prototype.compareCpm = function (oldItem, newItem) {
        this.type = RatecardComparator.getTypeFromTypeMap("cpm.amount");
        if (_.get(oldItem, "cpm.onRequest") === true) {
            this.oldValue = "auf Anfrage";
        }
        else if (_.get(oldItem, "cpm.amount")) {
            this.oldValue = _.get(oldItem, "cpm.amount");
        }
        if (_.get(newItem, "cpm.onRequest") === true) {
            this.newValue = "auf Anfrage";
        }
        else if (_.get(newItem, "cpm.amount")) {
            this.newValue = _.get(newItem, "cpm.amount");
        }
    };
    RatecardComparator.prototype.compareAdformat = function (oldItem, newItem, path) {
        var oldValue = _.get(oldItem, path);
        var newValue = _.get(newItem, path);
        if (!oldValue || !newValue) {
            return;
        }
        if (!RatecardComparator.jsonStringCompare(oldValue, newValue)) {
            this.oldValue = this.adformat;
            this.newValue = "n.A.";
            this.type = RatecardComparator.getTypeFromTypeMap(path);
        }
    };
    RatecardComparator.prototype.compareObjects = function (oldItem, newItem, path, arrayPath) {
        var oldValue = _.get(oldItem, path) || 0;
        var newValue = _.get(newItem, path) || 0;
        if (!oldValue && !newValue) {
            return;
        }
        if (_.isArray(oldValue) && arrayPath) {
            this.compareArray(oldValue, newValue, arrayPath);
            this.type = RatecardComparator.getTypeFromTypeMap(path);
        }
        else {
            if (!RatecardComparator.jsonStringCompare(oldValue, newValue)) {
                this.oldValue = RatecardComparator.toNumber(oldValue);
                this.newValue = RatecardComparator.toNumber(newValue);
                this.type = RatecardComparator.getTypeFromTypeMap(path);
            }
        }
    };
    RatecardComparator.prototype.compareArray = function (oldValue, newValue, path) {
        var _this = this;
        if (oldValue.length === 0) {
            this.oldValue = "n.A.";
            this.newValue = RatecardComparator.toNumber(_.get(newValue[0], path));
            return;
        }
        if (newValue.length === 0) {
            this.oldValue = RatecardComparator.toNumber(_.get(oldValue[0], path));
            this.newValue = "n.A.";
            return;
        }
        (oldValue).forEach(function (oldCand, i) {
            var newCand = newValue[i];
            var oldVal = _.get(oldCand, path);
            var newVal = _.get(newCand, path);
            if (!RatecardComparator.jsonStringCompare(oldVal, newVal)) {
                _this.oldValue = RatecardComparator.toNumber(oldVal);
                _this.newValue = RatecardComparator.toNumber(newVal);
                return;
            }
        });
    };
    RatecardComparator.getTypeFromTypeMap = function (input) {
        var result = this._typeMap[input];
        return result !== undefined ? result : input;
    };
    RatecardComparator.toNumber = function (input) {
        if (input === undefined) {
            return;
        }
        if (typeof input === "string") {
            return input;
        }
        return parseFloat(input.toString());
    };
    RatecardComparator.jsonStringCompare = function (val1, val2) {
        return JSON.stringify(val1) === JSON.stringify(val2);
    };
    RatecardComparator._typeMap = {
        "targeting": "targeting charge",
        "frequencyCapping.value": "frequency capping charge",
        "cpm.amount": "cpm",
        "fixedPrice": "fixed price"
    };
    return RatecardComparator;
}());
//# sourceMappingURL=ratecardChecker.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/ratecardChecker.js
// module id = 66
// module chunks = 0